import React, { useEffect } from "react";

import { useBottomMenu } from "../../../hooks/useBottomMenu";
import { useLabels } from "../../../hooks/useLabels";
import { IBottomMenuButton } from "../../bottom-menu/buttons";
import { labels as backgroundLabels } from "./labels";

import { useHasBottomRootMenu } from "../../../hooks/useHasBottomRootMenu";
import { useSetColorBackground } from "../background-color-panel/hooks/useSetColorBackground";
import { useSetPatternBackground } from "../background-pattern-panel/hooks/useSetPatternBackground";

import { useGoogleAnalytics } from "../../../hooks/useGoogleAnalytics";
import { BackgroundsBottomMenuIds, BottomMenuIds } from "../../bottom-menu/paths";
import { useBackgroundPatterns } from "../background-pattern-panel/hooks/useBackgroundPatterns";
import { BottomBackgroundMenu } from "./bottom-background-menu";
import { MenuIds, useMenus } from "../../../hooks/useMenus";

export const BottomBackgroundMenuContainer = () => {
	const { isVisible } = useBottomMenu();
	const {
		actions: { setMenu },
	} = useMenus();
	const hasRootMenu = useHasBottomRootMenu();
	const googleAnalytics = useGoogleAnalytics();

	const backgroundPatterns = useBackgroundPatterns();
	const [[colorTitle, patternsTitle], isLoadingLabels] = useLabels([
		backgroundLabels.colors,
		backgroundLabels.patterns,
	]);

	const canChangeColorBackgrounds = !!useSetColorBackground();
	const canChangePatternBackgrounds = !!useSetPatternBackground();
	const canChangeBackground = canChangeColorBackgrounds || canChangePatternBackgrounds;

	const menuItems: IBottomMenuButton<BackgroundsBottomMenuIds | "back">[] = [];

	menuItems.push({
		id: BottomMenuIds.BackgroundColor,
		iconName: "paint-background-color",
		title: colorTitle,
		isActive: isVisible(BottomMenuIds.BackgroundColor),
		onClick: () => {
			googleAnalytics.trackEventToGa({
				trackingAction: "BackgroundColorClicked",
			});
			setMenu(
				isVisible(BottomMenuIds.BackgroundColor)
					? MenuIds.Backgrounds
					: MenuIds.BackgroundColor,
			);
		},
	});

	menuItems.push({
		id: BottomMenuIds.BackgroundPattern,
		iconName: "paint-background-pattern",
		isDisabled: !(backgroundPatterns.length > 0),
		isActive: isVisible(BottomMenuIds.BackgroundPattern),
		title: patternsTitle,
		onClick: () => {
			googleAnalytics.trackEventToGa({
				trackingAction: "BackgroundPatternClicked",
			});
			setMenu(
				isVisible(BottomMenuIds.BackgroundPattern)
					? MenuIds.Backgrounds
					: MenuIds.BackgroundPattern,
			);
		},
	});

	// If product changes to one that doesn't has background support, go back to root
	useEffect(() => {
		if (!canChangeBackground) {
			// Go back
			setMenu(MenuIds.Root);
		}
	}, [canChangeBackground, setMenu]);

	if (isLoadingLabels) return null;

	return menuItems.length > 0 ? (
		<BottomBackgroundMenu
			onBack={() => setMenu(MenuIds.Root)}
			showBackButton={hasRootMenu}
			menuItems={menuItems}
		/>
	) : null;
};
